import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=6506c290&scoped=true"
import script from "./Update.vue?vue&type=script&lang=js"
export * from "./Update.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Update.vue?vue&type=style&index=1&id=6506c290&prod&lang=styl&scoped=true"
import style2 from "./Update.vue?vue&type=style&index=2&id=6506c290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6506c290",
  null
  
)

export default component.exports